class CustomizerSelectionState {
  constructor(orchestrator) {
    this.orchestrator = orchestrator;

    this.selectedColorKey = 'rosa';
    this.selectedArtKey = null;
    this.selectedFontKey = orchestrator.FONTS[0]?.key || null;
    this.selectedTextColor = '#FFFFFF';
    this.selectedInitialTextColor = '#FFFFFF';
    this.selectedNameTextColor = '#FFFFFF';
    this.selectedTextLayout = 'fullname';
    this.customText = '';
    this.activeCategoryKey = 'todas';

    this.applyToken = 0;

    this.textureCache = new Map();
    this.imageCache = new Map();
    this.bodyBaseCache = new Map();
    this.loadedFonts = new Set();

    this.fontCarouselReady = false;
    this.textInputTimer = null;

    this.artsGridElement = null;
    this.artsGridWrapElement = null;
    this.artsFadeAnimationFrame = 0;
    this.artsHasMoreCached = null;

    this.sidebarSheetExpanded = false;
    this.sidebarSheetHeightPercent = orchestrator.SIDEBAR_SHEET_DEFAULT;
  }

  getSelectedColor() {
    const { COLORS } = this.orchestrator;
    return COLORS[this.selectedColorKey] || COLORS.rosa;
  }

  getSelectedArt() {
    if (!this.selectedArtKey) return null;
    return (
      this.orchestrator.ARTS.find(art => art.key === this.selectedArtKey) ||
      null
    );
  }

  getSelectedFont() {
    const { FONTS } = this.orchestrator;
    return (
      FONTS.find(font => font.key === this.selectedFontKey) || FONTS[0] || null
    );
  }

  getTrimmedCustomText() {
    return this.customText.trim();
  }
}

window.CustomizerSelectionState = CustomizerSelectionState;
